
import { ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';
import { getTransactionTypeLabel } from "../TransactionTypeUtils";

interface TransactionTypePieChartProps {
  transactions: any[];
}

export const TransactionTypePieChart = ({ transactions }: TransactionTypePieChartProps) => {
  const transactionsByType = transactions.reduce((acc: any, transaction) => {
    const type = transaction.is_fully_paid === false ? "credit_sale" : transaction.transaction_type;
    const label = getTransactionTypeLabel(type);
    acc[label] = (acc[label] || 0) + 1;
    return acc;
  }, {});

  const pieChartData = Object.entries(transactionsByType).map(([name, value]) => ({
    name,
    value,
  }));

  const COLORS = ['#3b82f6', '#22c55e', '#f59e0b', '#ef4444', '#8b5cf6'];

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={pieChartData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={80}
          fill="#8884d8"
          label
        >
          {pieChartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
